import Vue from 'vue'
import App from './App'
import store from './store'
import router from 'router'
import './config'
import './interceptor'
import {
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Pagination,
  Dialog,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Input,
  InputNumber,
  Radio,
  RadioGroup,
  CheckboxGroup,
  RadioButton,
  Checkbox,
  Select,
  Option,
  Button,
  Table,
  TableColumn,
  DatePicker,
  TimeSelect,
  TimePicker,
  Popover,
  Tooltip,
  Form,
  FormItem,
  Breadcrumb,
  BreadcrumbItem,
  Tabs,
  TabPane,
  Alert,
  Icon,
  Row,
  Col,
  Upload,
  Card,
  Loading,
  MessageBox,
  Message,
  Notification,
  Rate,
  Slider,
  Steps,
  Step,
  Progress,
  Divider,
  Autocomplete,
  Switch,
  Tag,
  Link
} from 'element-ui'

Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Pagination)
Vue.use(Dialog)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(CheckboxGroup)
Vue.use(RadioButton)
Vue.use(Checkbox)
Vue.use(Select)
Vue.use(Option)
Vue.use(Button)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(DatePicker)
Vue.use(TimeSelect)
Vue.use(TimePicker)
Vue.use(Popover)
Vue.use(Tooltip)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Alert)
Vue.use(Icon)
Vue.use(Row)
Vue.use(Col)
Vue.use(Upload)
Vue.use(Card)
Vue.use(Rate)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Slider)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Progress)
Vue.use(Divider)
Vue.use(Autocomplete)
Vue.use(Switch)
Vue.use(Tag)
Vue.use(Link)
Vue.use(Loading.directive)

Vue.prototype.$loading = Loading.service
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$notify = Notification
Vue.prototype.$message = Message

Vue.prototype.$alert = MessageBox.alert
/* eslint-disable no-new */
var vueInstance = new Vue({
  router,
  store,
  el: '#app',
  render: h => h(App)
})

export default vueInstance


// WEBPACK FOOTER //
// ./app/index.js